import { BASE_URL } from "../../env";
import "../../features/members/screens/MemberPrint.css";
import {
  getCurrentDateInIST,
  getCurrentTimeInIST,
  formatISODateToLocalDMY,
  calculateEmiAmountRaw,
} from "../../utils/utils";

const GoldCustodyAcknowledgementReceipt = ({ memberDetails }) => {
  // EMI calculation function. calculateEmiAmountRaw already returns
  // principal/tenureInMonths for a 0% rate (the same simple division this
  // used to do itself), so the whole-rupee rounding here is the only step
  // left to do at this call site.
  const calculateEMI = (principal, rateOfInterest, tenureInMonths) =>
    Math.round(calculateEmiAmountRaw(principal, rateOfInterest, tenureInMonths));

  // Calculate EMI using the available details
  const calculatedEMI = calculateEMI(
    memberDetails.memberDetails.eligibleLoanAmountByBm,
    memberDetails.proposedLoanDetails.rateOfInterest,
    memberDetails.proposedLoanDetails.tenureInMonths
  );

  return (
    <div className="section sanction-letter-section m-1">
      <table
        className="table table-bordered"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          border: "1px solid black",
        }}
      >
        <tbody>
          <tr className="text-center">
            <th colSpan={6} style={{ fontSize: "40px" }}>
              Vetrivikas Capital Trust
            </th>
          </tr>
          <tr className="text-center">
            <th colSpan={6}>GOLD CUSTODY ACKNOWLEDGEMENT RECEIPT</th>
          </tr>
          <tr>
            <th>Regional</th>
            <td>Madurai(01)</td>
            <th>Partner</th>
            <td>{memberDetails.branchName}</td>
            <th>Date & Time</th>
            <td>{memberDetails.memberDetails.creditManagerStatusUpdatedAt}</td>
          </tr>
          <tr>
            <th>Name</th>
            <th>Address</th>
            <th>Customer ID</th>
            <td>{memberDetails.memberDetails.customerId}</td>
            <th>Receipt No</th>
            <td>{memberDetails.memberDetails.loanId}</td>
          </tr>
          <tr>
            <td rowSpan={3}>{memberDetails.memberDetails.memberName}</td>
            <td>
              {memberDetails.memberDetails.permanentDoorNo +
                "," +
                memberDetails.memberDetails.permanentStreetNo +
                "," +
                memberDetails.memberDetails.permanentPanchayat}
            </td>
            <th>Facility</th>
            <td>Gold Purchase Loan</td>
            <th>Applicant Photo</th>
            <th>Gold Photo</th>
          </tr>
          <tr>
            <td>{memberDetails.memberDetails.permanentTaluk}</td>
            <th>LAN No</th>
            <td>{memberDetails.memberDetails.ApplicationId}</td>
            <td rowSpan={8}>
              <img
                src={`${BASE_URL}/images/${memberDetails.memberDocuments.memberPhoto}`}
                alt=""
                style={{ width: "300px", height: "300px" }}
              />
            </td>
            <td rowSpan={8}>
              <img
                src={`${BASE_URL}/images/${memberDetails.bookingProcessDetails.ornamentPhoto}`}
                alt=""
                style={{ width: "300px", height: "300px" }}
              />
            </td>
          </tr>
          <tr>
            <td>
              {memberDetails.memberDetails.permanentDistrict +
                "-" +
                memberDetails.memberDetails.permanentPincode}
            </td>
            <th>Loan Amount</th>
            <td>{memberDetails.memberDetails.eligibleLoanAmountByBm}</td>
          </tr>
          <tr>
            <th>Mobile No</th>
            <td>{memberDetails.memberDetails.phoneNumber}</td>
            <th>Period of Loan</th>
            <td>
              {memberDetails.proposedLoanDetails.tenureInMonths + " Months"}
            </td>
          </tr>
          <tr>
            <th>Occupation</th>
            <td></td>
            <th>EMI Date</th>
            <td>{memberDetails.memberDetails.emiDateByBranchManager}</td>
          </tr>
          <tr>
            <th>Purpose</th>
            <td></td>
            <th>ROI</th>
            <td>{memberDetails.proposedLoanDetails.rateOfInterest}</td>
          </tr>
          <tr>
            <th>Rate Per Gram</th>
            <td>{memberDetails.memberDetails.goldRateByBm}</td>
            <th>EMI Amount</th>
            <td>{calculatedEMI}</td>
          </tr>
          <tr>
            <th>Mode of Repayment</th>
            <td>Cash</td>
            <th>Disb date</th>
            <td>
                {memberDetails.memberDetails.creditManagerStatusUpdatedAt}
            
            </td>
          </tr>
          <tr>
            <th>Nominee Name</th>
            <td>{memberDetails.coApplicantDetails.coApplicantName}</td>
            <th>Relationship</th>
            <td> {memberDetails.coApplicantDetails.relation}</td>
          </tr>
          <tr>
            <th>Ornament Model No</th>
            <th>Ornament Model</th>
            <th>Ornament Weight</th>
            <th>Ornament Total Value</th>
            <th>Rate Per Gram(Booking Day Rate)</th>
            <th>Eligible Loan Amount</th>
          </tr>
          <tr>
            <td>{memberDetails.memberDetails.ornamentModelNoByBm}</td>
            <td>{memberDetails.memberDetails.ornamentNameByBm}</td>
            <td>{memberDetails.memberDetails.ornamentWeightByBm}</td>
            <td>{memberDetails.memberDetails.ornamentWeightValueByBm}</td>
            <td>{memberDetails.memberDetails.goldRateByBm}</td>
            <td>{memberDetails.memberDetails.eligibleLoanAmountByBm}</td>
          </tr>
          <tr>
            <th>Custody Declaration</th>
            <td colSpan={5}>
              This is to acknowledge that _______________________ has taken
              custody of the above-mentioned gold ornaments purchased through
              the Gold Purchase Loan scheme. The ornaments will be held in safe
              custody at the company's designated secure facility till the
              closure or settlement of the associated loan account. The customer
              has physically verified the ornaments post-purchase and consented
              to deposit the same as collateral for the above loan.
            </td>
          </tr>
          <tr>
            <th>Important Notes:</th>
            <td colSpan={5}>
              1. The ornaments remain the property of the customer, held solely
              as collateral security.
              <br /> 2. The ornaments will be returned upon full repayment of
              the loan and completion of applicable release formalities. <br />
              3. In the event of non-payment as per the loan agreement, the
              company reserves the right to proceed with recovery actions,
              including auction as per agreed terms.
            </td>
          </tr>
          <tr>
            <th
              colSpan={2}
              className="text-center"
              style={{ height: "100px", verticalAlign: "bottom" }}
            >
              Customer Signature
            </th>
            <th
              colSpan={2}
              className="text-center"
              style={{ height: "100px", verticalAlign: "bottom" }}
            >
              Branch Manager Signature
            </th>
            <th
              colSpan={2}
              className="text-center"
              style={{ height: "100px", verticalAlign: "bottom" }}
            >
              Custody Officer(HO) Signature
            </th>
          </tr>
          <tr>
            <th colSpan={6} className="text-center">
              47/4, PTR Tower, 4th Floor , Bye pass road, Ponmeni ( Near Kumar
              Mess ), Madurai - 625016. Tel : 0452 4909438
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default GoldCustodyAcknowledgementReceipt;